import React from "react";
import { Navigate } from "react-router-dom";
import { useCustomerAuth } from "@/customer/AuthContext";

export const ProtectedCustomerRoute = ({ children }) => {
  const { user, loading } = useCustomerAuth();
  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-white/50 text-xs tracking-luxe uppercase">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
};

export default ProtectedCustomerRoute;
